import React from 'react';
import type { PatientDetailsPatientProp } from './internal';
import { PatientDetailsSection } from './internal';
import { intl } from '../../lib';
import { HBox, VBox } from '../layout';
import { PersonImage } from '../basic';
import type { PatientDetailsProps } from './PatientDetails';

/**
 * Props for a {@link PatientDetailsPictures} component.
 * @author agd
 */
export type PatientDetailsPicturesProps = PatientDetailsPatientProp &
  Pick<PatientDetailsProps, 'mobileAppBarcodeHidden'>;

/**
 * Component for displaying a patient's avatar image and qrCodeSVG.
 *
 * @param properties a {@link PatientDetailsPicturesProps} object
 * @return the created {@link JSX.Element}.
 * @author agd
 * @constructor
 */
export function PatientDetailsPictures({
  patient,
  mobileAppBarcodeHidden
}: PatientDetailsPicturesProps): JSX.Element {
  return (
    <PatientDetailsSection
      className="ehs-patient-details-pictures"
      title={intl('view.patient.detail.title')}
    >
      <HBox className="details">
        <VBox>
          <PersonImage
            emptyState="defaultAvatar"
            image={patient.profileImage}
            className="profile-image"
          />
          <span className="label">
            {intl('patientsearchportlet.view.details.userimage')}
          </span>
        </VBox>
        {!mobileAppBarcodeHidden && patient.qrQodeSVG && (
          <VBox>
            <div
              className="qr-code-svg"
              // TODO: can this be done in a better way?
              dangerouslySetInnerHTML={{ __html: patient.qrQodeSVG }}
            />
            <span className="label">
              {intl('patientsearchportlet.view.details.qrcode')}
            </span>
          </VBox>
        )}
      </HBox>
    </PatientDetailsSection>
  );
}
